webpackJsonp([48006439568790],{

/***/ 588:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Burle Marx – Escritório de Paisagismo"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---projetos-d1a3736f2fcf2d08c37c.js